/**
 * @copyright © Paramount Streaming
 * @description Default server base URLs for the Pluto TV converged adapter.
 * The calling application can override these at runtime via paramsVO.STITCHER.servers.
 */
export const PLUTO_CONVERGED_BASE_URL = 'https://stage.pluto.tv';
export const PLUTO_STITCHER_GATEWAY_URL = 'https://playout-gateway-pluto-us-stage.gcp-dev-usc1.pluto.tv';

/** Universal End Cards / up-next recommendation API base (browser). */
export const PLUTO_UEC_URL = 'https://api-web-pluto-us-stage.gcp-dev-usc1.pluto.tv';

/** Next-item (episode-to-episode) API base; override independently via `STITCHER.servers.nextItem`. */
export const PLUTO_NEXT_ITEM_URL = PLUTO_UEC_URL;

/** External API Router base (browser); paths include `/{device}/api/...` — see PlutoAdapter. */
export const PLUTO_APPS_API_BASE_URL = `${PLUTO_CONVERGED_BASE_URL}/apps-api`;

export const PLUTO_SERVERS = {
	channels: PLUTO_APPS_API_BASE_URL,
	vod: PLUTO_APPS_API_BASE_URL,
	uec: PLUTO_UEC_URL,
	nextItem: PLUTO_NEXT_ITEM_URL
} as const;

/** Default device path segment for desktop web on the API Router (converged apps-api URLs). */
export const PLUTO_DEFAULT_DEVICE = 'web';